// 🔧 passport_generator.js
// ✅ Purpose: Generates adaptive Passport demo data
// ✅ Features:
// - Always creates Core Passport stops
// - Adds Sponsor/Vendor/Auction/Store/Ticket stops only when those engines ran
// - Generates rewards and achievements
// - Generates sample attendee progress
// - No Firestore writes
// - No DemoContext mutation
// - Fully block-commented for clarity and future devs

import { buildPassportDefaults } from "./templates/passport_defaults";

export const generatePassport = ({ demoContext } = {}) => {
  console.log("🛂 Passport Generator started.");

  const industryTemplate =
    demoContext?.industryTemplate?.key ||
    demoContext?.demoConfig?.industry ||
    "car_show";

  const demoSize =
    demoContext?.demoConfig?.size ||
    demoContext?.seedProfile?.demoSize ||
    "medium";

  const passportData = buildPassportDefaults({
    industryTemplate,
    demoSize,
    demoContext,
  });

  console.log("✅ Passport Generator completed.", {
    stops: passportData.stops.length,
    rewards: passportData.rewards.length,
    achievements: passportData.achievements.length,
    progress: passportData.progress.length,
  });

  return passportData;
};
